module.exports = __webpack_public_path__ + "static/media/mama-burger-mb-en.eb7d6b63.jpg";